












import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import Chime from "@/resources/mixins/chime/chime";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
@Component({
  name: "video-menu-component",
  directives: { ClickOutsideDirective },
})
export default class AudioMenuComponent extends mixins(
  FloatMenuAnimation,
  Chime
) {
  close() {
    const menu = document.getElementById("video-menu");
    if (menu.style.display === "block") this.closeVideoMenu();
  }
}
